<template>
  <div class="position-relative">
    <div class="add-entity-action d-flex align-center justify-end">
      <v-btn
        height="42"
        class="px-5"
        @click="openEntityDialog = true"
        :disabled="store.state.isWorkflowDisabled"
      >
        <v-icon>mdi-plus</v-icon>
        Entity
      </v-btn>
      <create-entity-dialog v-model="openEntityDialog" />
    </div>
    <div class="mt-10">
      <beam-table
        v-for="(entity, index) in (workflow.dataModels || [])"
        :key="entity.id"
        :data-model="entity"
        :index-data-model="index"
        :dimensions="workflow.dataModels || []"
        @blur-data-model-name="(e) => blurEntityName(e, index)"
        @delete-data-model="setShowDeleteDialog('entity', { index })"
        @blur-table-cell="blurTableCell"
        @add-column="addColumn"
        @delete-data-field="(index1, index2) => setShowDeleteDialog('entity-data-field', { index1, index2 })"
        @move-left="moveLeft"
        @move-right="moveRight"
        @generate-example-data="generateExampleData"
        :rows="[
          {
            type: 'header',
            fieldName: 'name',
            rowLabel: 'Entity'
          },
          {
            type: 'relation',
            fieldName: 'relatedEntityId'
          },
          {
            type: 'example-data',
            fieldName: 'exampleData'
          }
        ]"
      />
      <v-card v-if="!workflow.dataModels?.length" flat color="white" class="mb-4 elevation-2 rounded px-3 py-3 border-0">
        <div class="d-flex align-center mb-6">
          No&nbsp;<span class="main-badge">Entities</span>&nbsp;created yet.
          <help-dialog-workflow-entities />
        </div>
        <div>
          Click on <span class="main-badge">+ Entity</span> to create an entity.
        </div>
      </v-card>
    </div>

    <delete-confirmation-dialog
      v-model="openDeleteDialog"
      :title="dialogInfo.title"
      :text="dialogInfo.text"
      :onDelete="dialogInfo.action"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import BeamTable from '@/components/BeamTable.vue'
import CreateEntityDialog from '@/components/CreateEntityDialog.vue'
import DeleteConfirmationDialog from '@/components/DeleteConfirmationDialog.vue'
import useEntityActions from '@/composables/useEntityActions'
import HelpDialogWorkflowEntities from '@/components/HelpDialogWorkflowEntities.vue'

const store = useStore()
const workflow = computed(() => store.state.workflow.workflow)

const openEntityDialog = ref(false)
const openDeleteDialog = ref(false)
const dialogInfo = ref({ title: '', text: '', action: null })

const {
  moveRight,
  moveLeft,
  blurEntityName,
  blurTableCell,
  addColumn,
  deleteEntity,
  deleteEntityField,
  generateExampleData
} = useEntityActions()

const setShowDeleteDialog = (type, data) => {
  openDeleteDialog.value = true

  switch (type) {
    case 'entity':
      dialogInfo.value = {
        title: 'Confirm data model deletion',
        text: 'Are you sure you want to delete this data model entity?',
        action: () => deleteEntity(data.index)
      }
      break
    case 'entity-data-field':
      dialogInfo.value = {
        title: 'Confirm data model field deletion',
        text: 'Are you sure you want to delete this field?',
        action: () => deleteEntityField(data.index1, data.index2)
      }
      break
  }
}

</script>

<style scoped>
.add-entity-action {
  margin-top: -40px;
}
</style>
